import { useTranslation } from "@privacy/translations";
import { DialogContent, DialogTitle, DialogActions, Button, Dialog, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import { useMutation } from "@tanstack/react-query";
import * as FormDialog from "../../shared/FormDialog";

export const DpiaApprovalDialog: FC<{
  headerText: string;
  message: ReactNode;
  submitButtonLabel: string;
  onClose: () => void;
  onSubmit: () => Promise<unknown>;
}> = ({ headerText, message, submitButtonLabel, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const mutation = useMutation({ mutationFn: onSubmit });

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{headerText}</DialogTitle>

      <DialogContent>
        <FormDialog.FormError isError={mutation.isError} />
        <Typography
          sx={{ fontSize: theme => theme.typography.pxToRem(14), color: theme => theme.palette.text.secondary }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          {t("ConfirmDeleteDialog.CancelButton")}
        </Button>
        <Button loading={mutation.isPending} onClick={() => mutation.mutate()}>
          {submitButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
